<template>
  <div class="_taskView">

    <md-checkbox 
      class="_taskView__checkbox"
      v-model="isCompleteInOrder"
      :disabled="true"
    >Complete In Order</md-checkbox>
    <div class="dynamicList-loading-spinner" v-show="promisePending">
      <md-progress-spinner :md-diameter="30" :md-stroke="3" md-mode="indeterminate"></md-progress-spinner>
    </div>
    <div class="selectStatusBox">
      <md-field class="_uiKitInput">
        <label>Status</label>
        <md-select v-model="taskFilter" :disabled="isRefreshing">
          <md-option 
            v-for="_option in taskFilterOptions" 
            :key="_option"
            :value="_option" 
          > {{ _option }} </md-option>
        </md-select>
      </md-field>
    </div>
    <md-table :value="filteredTasks" class="paginated-table table-striped table-hover _taskView__table">
      <md-table-row slot="md-table-row" slot-scope="{ item }" :class="applyColor(item)">
        <md-table-cell md-label="Task" md-sort-by="id">
          <CaseTaskViewTaskComponent
            :task="item"
            :isCompleteInOrder="isCompleteInOrder"
            :atTaskUpdate="onTaskUpdate"
            :isRefreshing="isRefreshing"
          ></CaseTaskViewTaskComponent>
        </md-table-cell>
        
        <md-table-cell md-label="Steps" md-sort-by="name">
          <CaseTaskViewStepsListComponent
            :task="item"
            :steps="item.steps ? item.steps.items: []"
            :atStepUpdate="onStepUpdate"
            :isRefreshing="isRefreshing"
          ></CaseTaskViewStepsListComponent>
        </md-table-cell>
        
        <!-- <md-table-cell md-label="Is Available" md-sort-by="email">
          <span>{{ item.isAvailable }}</span>
        </md-table-cell> -->
        
        <md-table-cell md-label="Status" md-sort-by="email">
          <span>{{ item.status }}</span>
        </md-table-cell>
        
        <md-table-cell md-label="Due Date" md-sort-by="gender">
          <span>{{ item.dateDue | formatDate }}</span>
        </md-table-cell>
        
        <md-table-cell md-label="Assigned To" md-sort-by="title">
          <span>{{ item | assigneeName }}</span>
        </md-table-cell>
        
        <md-table-cell md-label="Actions" md-sort-by="title">
          <md-button 
            title="View Task"
            class="md-just-icon md-simple _dark" 
            @click.stop.native="handleEdit(item)"
          ><md-icon>description</md-icon></md-button>
          <md-button 
            title="Add Comment"
            class="md-just-icon md-simple _dark" 
            @click.stop.native="onComment(item)"
          ><md-icon>mode_comment</md-icon></md-button>
          <md-button 
            title="Delete Task"
            v-if="$Session.isAdminGroupMember" 
            class="md-just-icon md-danger md-simple" 
            @click.stop.native="onDelete(item)"
          ><md-icon>close</md-icon></md-button>
        </md-table-cell>
      </md-table-row>
    </md-table>
    
    <md-dialog :md-active.sync="isCommentDialogOpen" style="max-width: 840px;">
      <md-dialog-title>Add Comment</md-dialog-title>
      <md-dialog-content>
        <CaseTaskViewCommentComponent
          :recordData="commentTask"
          :atClose="onCommentDialogClose"
        ></CaseTaskViewCommentComponent>
      </md-dialog-content>
    </md-dialog>
    
  </div>
</template>

<script>
import _ from 'lodash';
import moment from 'moment'
import Swal from "sweetalert2";

import Amplify, { Auth, API, graphqlOperation } from 'aws-amplify';
import * as queries_custom from '@/graphql/queries_custom';
import * as mutations from '@/graphql/mutations';

import RecordList from '@/mixins/RecordList';
const RecordListMixin = {
  methods: {
    handleDelete: RecordList.methods.handleDelete,
    delete: RecordList.methods.delete,
    deleteRecord: RecordList.methods.deleteRecord,
    deleteSyncRecord: RecordList.methods.deleteSyncRecord,
    afterDelete: RecordList.methods.afterDelete,
    // handleEdit: RecordList.methods.handleEdit,
  }
};

import CaseTaskViewStepsListComponent from "@/components/DynamicForm/CaseTaskView/CaseTaskViewStepsListComponent";
import CaseTaskViewTaskComponent from "@/components/DynamicForm/CaseTaskView/CaseTaskViewTaskComponent";
import CaseTaskViewCommentComponent from "@/components/DynamicForm/CaseTaskView/CaseTaskViewCommentComponent";

export default {
  mixins: [RecordListMixin],
  components: {
    CaseTaskViewStepsListComponent,
    CaseTaskViewTaskComponent,
    CaseTaskViewCommentComponent,
  },
  props: {
    caseId: {
      type: String,
      required: true,
    },
    forceRefresh: {
      required: false,
    },
    urlHash: {
      type: String,
    },
  },
  data: () => ({
    promisePending: false,
    case: {},
    tasks: [],
    taskFilter: 'Open',
    taskFilterOptions: ['All', 'Open', 'Completed'],
    isRefreshing: false,
    isCompleteInOrder: false,
    hashUrlTaskId: null,
    list: {
      editPath: "tasks",
      deleteQueryId: "deleteTask",
      deleteMessageNameFields: ['subject'],
    },
    commentTask: null,
    isCommentDialogOpen: false,
  }),
  computed: {
    sortedTasks() {
      return _.sortBy(this.tasks, ['group', 'order']);
    },
    filteredTasks() {
      // filter internal tasks
      let tasks = this.sortedTasks.filter(_task => {
        return !_task.internal || this.$Session.isInternalGroupMember;
      });

      // show all tasks
      if ('All' == this.taskFilter) {
        return tasks;
      }
      
      // show only open tasks
      if ('Open' == this.taskFilter) {
        if (this.isCompleteInOrder) {
          return tasks.filter(_task => _task.isAvailable);
        }
        return tasks.filter(_task => 'Open' == _task.status);
      }
      
      // show completed tasks
      return tasks.filter(_task => 'Completed' == _task.status);
    }
  },
  mounted() {
    this.selectLoadedTask();
    this.getCase(true);
    window.$bus.$on('caseTaskView.forceUpdate', () => {
      this.getCase();
    });
  },
  methods: {
    // checkServicePendingResponce(response) {
    //   const serviceItems = response.data.getCase.services.items;
    //   let taskDetails = [];
    //   if(serviceItems.length > 0) {
    //     if(serviceItems[0].service.status != "Pending") {
    //       let items = response.data.getCase.tasks.items;
    //       items.forEach((item, index) => {
    //         if (item.subject != "Follow up on Pending") {
    //           taskDetails.push(item);
    //         }
    //       });
    //     } else {
    //       return response.data.getCase.tasks.items;
    //     }
    //   }
    //   return taskDetails;
    // },
    applyColor(item){
      if(this.hashUrlTaskId){
        return this.hashUrlTaskId === item.id ? 'taskRowColor' : '' ;
      }
    },
    handleEdit(task) {
      window.$bus.$emit('caseTaskView.task.click', task);
    },
    async getCase(shouldForceUpdate) {
      this.isRefreshing = true;
      const operation = graphqlOperation(queries_custom.editCase, {
        input: { id: this.caseId },
        id: this.caseId,
      });
      API.graphql(operation)
        .then(response => {
          // ATLAS-862 - workflow
          // let getCaseTasks = this.checkServicePendingResponce(response);
          this.$set(this, 'case', response.data.getCase);
          this.$set(this, 'tasks', response.data.getCase.tasks.items);
          // this.$set(this, 'tasks', getCaseTasks);
          for (let task of this.tasks) {
            if (task.isCompleteInOrder) {
              let steps = task.steps.items;
              if(steps && steps.length) {
                steps = _.orderBy(steps, 'order');
                const firstAvailableStep = steps.find(_step => {
                  return _step.status && 'complete' != _step.status.toLowerCase();
                });
                steps.map(_step => {
                  _step.isAvailable = false;
                });
                if (firstAvailableStep) {
                  firstAvailableStep.isAvailable = true;
                }
              }
            }
          }
          
          if (shouldForceUpdate && this.case && this.case.isCompleteInOrder) {
            this.forceCompleteInOrder();
          }
          
          this.isRefreshing = false;
          this.promisePending = false;
        })
        .catch(error => {
          console.log(error);
          this.$set(this, 'case', error.data.getCase);
          this.$set(this, 'tasks', error.data.getCase.tasks.items);
          // this.$set(this, 'tasks', getCaseTasks);
          for (let task of this.tasks) {
            if (task.isCompleteInOrder) {
              const steps = task.steps.items;
              if(steps && steps.length) {
                steps = _.orderBy(steps, 'order');
                const firstAvailableStep = steps.find(_step => {
                  return _step.status && 'complete' != _step.status.toLowerCase();
                });
                steps.map(_step => {
                  _step.isAvailable = false;
                });
                if (firstAvailableStep) {
                  firstAvailableStep.isAvailable = true;
                }
              }
            }
          }
          
          if (shouldForceUpdate && this.case && this.case.isCompleteInOrder) {
            this.forceCompleteInOrder();
          }
          this.isRefreshing = false;
          this.promisePending = false;
        });
    },
    onStepUpdate() {
      this.promisePending = true;
      this.isRefreshing = true;
    },
    onTaskUpdate() {
      this.promisePending = true;
      this.isRefreshing = true;
      setTimeout(() => {
        this.getCase();
        window.$bus.$emit('caseTaskView.updated');
      }, 1000);
    },
    onComment(task) {
      this.commentTask = task;
      this.isCommentDialogOpen = true;
    },
    onCommentDialogClose() {
      this.isCommentDialogOpen = false;
    },
    async onDelete(task) {
      await this.handleDelete(task);
      setTimeout(() => {
        this.getCase();
      }, 5000);
    },
    /**
     * @description
     * In some edge cases - there might be more than 1 group available at the 
     * same time - cater all such edge cases
     * In most cases this is due to the workflowServiceTrigger and auditTrail
     * Lambda triggers invoking at the same time
     * Make sure only one group of tasks are active at a time
     * 
     * @see
     * ATLAS-1228
     * <Service><Workflow>The tasks are being displayed in wrong group after they are open again
     * https://zeamster.atlassian.net/browse/ATLAS-1228
     * 
     * @returns {Void}
     */
    async forceCompleteInOrder() {
      let activeGroupIndex = -1;
      const openGroups = []
      const groups = _.groupBy(this.tasks, 'group');
      
      // find all open groups
      for (const key in groups) {
        const tasks = _.sortBy(groups[key], 'order');
        const openTasks = tasks.filter(_task => _task && _task.isAvailable);
        if (openTasks.length) {
          openGroups.push(openTasks)
        }
      }
      
      // if only one group is open then bail
      if (openGroups.length <= 1) {
        return;
      }
      
      // start loader
      this.isRefreshing = true;
      
      // create promises to update open tasks in any group other than first
      const promises = [];
      for (let i = 1; i < openGroups.length; i++) {
        openGroups[i].forEach((_task) => {
          _task.isAvailable = false;
          const input = {
            id: _task.id,
            isAvailable: false,
          };
          const operation = graphqlOperation(mutations.updateTask, { input });
          promises.push(API.graphql(operation));
        });
      }
      
      // wait for all promises to resolve - then reload tasks
      await Promise.all(promises);
      this.getCase();
    },
    selectLoadedTask(){
      let hashUrlObj = this.$route.hash.split('/')

      if(hashUrlObj[0] === '#' && hashUrlObj[1] === 'tasks'){
        this.$set(this, 'taskFilter', 'All');        
        this.hashUrlTaskId = hashUrlObj[2];
      }
    }
  },
  filters: {
    formatDate(value) {
      try {
        return moment(String(value)).format('MMM DD, YYYY')
      } catch (e) {
        return value;
      }
    },
    assigneeName(task) {
      const user = task.user;
      if (!user) {
        return '';
      }
      return `${user.given_name} ${user.family_name}`;
    }
  },
  watch: {
    caseId: {
      handler: function() {
        this.getCase(true);
      }
    },
    'case.isCompleteInOrder': {
      handler: function() {
        this.isCompleteInOrder = this.case.isCompleteInOrder;
      }
    },
    'urlHash': {
      handler: function() {
        this.selectLoadedTask();
      }
    },
  }
};
</script>

<style lang="scss">
._taskView__table {
  
  .md-table-content {
    table,
    th,
    td {
      border: 1px solid #ddd !important;
    }
    
    tr {
      background-color: transparent;
    }
    
    tbody tr {
      background-color: transparent;
      &:hover {
        background-color: #f9f9f9;
      }
    }
    
    th,
    td {
      padding: 10px;
    }
    
    th {
      font-size: 14px;
      font-weight: 500;
      
      &:nth-child(1),
      &:nth-child(2) {
        width: 30%;
      }
    }
    
    td {
      font-size: 13px;
      font-weight: normal;
    }
  }
    
  .md-table-head-container {
    padding: 0 5px !important;
  }
  
  .md-table-head:last-child {
    border-top: 0 !important;
    border-right: 0 !important;
    border-left: 0 !important;
  }
  
  .md-table-head-label {
    font-size: inherit;
    font-weight: 500;
  }
  
  .md-table-head:last-child .md-table-head-label {
    padding-right: 0 !important;
  }
  
  .md-table-cell-container {
    padding: 0 10px;
  }
  
  .md-checkbox {
    margin: 0;
  }
  
  .md-just-icon {
    margin: 0;
  }
  
  ._dark i {
    color: #56597b !important;
    transition: color 0.15s;
  }
  
  ._dark:hover i {
    color: #252742 !important;
  }

  ._taskView__toolbar {
    display: block;
    margin-top: -20px;
    margin-bottom: 50px;
    
    .md-field {
      width: 200px;
      margin-top: 15px;
    }
    
    .md-checkbox {
      margin: 20px 0;
    }
  }
  
  ._taskView__steps__step {
    margin: 5px 0;
    
    .md-checkbox-label {
      font-weight: normal;
    }
  }
}

._taskView__checkbox {
  position: absolute;
  top: 40px;
}

._taskView__steps__header,
._taskView__steps__list {
  position: relative;
  margin-left: 15px;
  padding-top: 10px;
  padding-left: 15px;
  
  &::after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 15px;
    left: 0;
    border-left: 1px solid #ddd;
  }
}

._taskView__steps__title,
._taskView__steps__step {
  position: relative;
  
  &::before,
  &::after {
    content: '';
    position: absolute;
    top: 50%;
    right: 100%;
  }
  
  &::after {
    width: 15px;
    margin-top: -4px;
    border-top: 1px solid #ddd;
  }
  
  &::before {
    margin-top: -10px;
    margin-right: 3px;
    border: 6px solid transparent;
    border-left-color: #ddd;
  }
}

._taskView__steps__header {
  margin-top: -5px;
  margin-left: 0;
  
  &::after {
    bottom: 20px;
  }
}

._taskView__steps__title {
  padding-bottom: 5px;
  padding-left: 5px;
}

._taskView__comment {
  
  .mce-tinymce {
    box-shadow: none;
  }
  
  .md-card-actions {
    padding: 0;
    margin-top: 20px;
  }
  
  .md-button+.md-button {
    margin-left: 15px;
  }
} 

._taskView__task {
  display: flex;
  align-items: center;
}

._taskView__task__label {
  cursor: pointer;
  margin-left: 1rem;
}

.taskRowColor {
  background-color: #2196f37d !important;
}

.selectStatusBox{
  display: block;
  margin-top: -10px;
  margin-bottom: 50px;
  width: 15%;
}
</style>
